import { render, staticRenderFns } from "./ListAttachmentGroup.vue?vue&type=template&id=47b231db"
import script from "./ListAttachmentGroup.vue?vue&type=script&lang=js"
export * from "./ListAttachmentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports